import { render, staticRenderFns } from "./order.vue?vue&type=template&id=b1ab27d6&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=b1ab27d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab27d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ab27d6')) {
      api.createRecord('b1ab27d6', component.options)
    } else {
      api.reload('b1ab27d6', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=b1ab27d6&scoped=true&", function () {
      api.rerender('b1ab27d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecommerce/order.vue"
export default component.exports